// extracted by mini-css-extract-plugin
export default {"page":"SizesPage_page__5HLxH","header":"SizesPage_header__7jwZn","pane":"SizesPage_pane__84LRS"};